import { SeonService } from '../services/seon/seon.service';

interface CustomerInfo {
  name: string;
  email: string;
  phoneNumber: string;
  isGuest: boolean;
  lastOrder?: {
    orderShortCode: string | null;
  } | null;
  sessionHash: string| null;
}

interface Message {
  actionType: string;
  actionData: {
    name: string;
    email: string | null;
    phone: string | null;
    isGuestUser: string;
    // isLoyaltyMember: boolean;
    channel: string;
    orderId: string | null;    
    sessionHash: string | null;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             pany?: string | null;
  };
}

export function sendMessageToChatIframe(customerInfo: CustomerInfo): void {
  const message: Message = {
    actionType: 'ameliaConversationAttributes',
    actionData: {
      name: customerInfo.name,
      email: customerInfo.email ?? null,
      phone: customerInfo?.phoneNumber ?? null,
      isGuestUser: customerInfo?.isGuest === undefined ? 'true' : JSON.stringify(customerInfo?.isGuest),
      // isLoyaltyMember: this.loyaltyService.isEnrolledInLoyalty(customerInfo),
      channel: "web",
      orderId: customerInfo.lastOrder?.orderShortCode ?? null,
      sessionHash: customerInfo.sessionHash
    },
  };

  const iframe = getChatIframe();
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(message, iframe.src);
  }
}

export function getChatIframe(): HTMLIFrameElement | null {
  return document.getElementById('amelia-chat-overlay-iframe') as HTMLIFrameElement | null;
}

export function getChatContainer(): HTMLElement | null {
  return document.getElementById('amelia-chat-overlay-container');
}

export function showChatButton(): void {
  const button = document.querySelector('.amelia-chat-overlay-floating-button') as HTMLElement | null;
  if (button) {
    button.click();
  }
}

export function hideChatWindow(): void {
  const iframe = getChatIframe();
  if (iframe) {
    iframe.style.display = 'none';
  }
  const container = getChatContainer();
  if (container) {
    container.style.display = 'none';
  }
}